import type { FC } from "react";
import Lookup from "../../organisms/Lookup";
import TitleUF from "../../atoms/typography/TitleUF";
import { HorizontalSpacer } from "../../atoms/Spacers";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ClientsPage: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onClickItem = (item: {
    clientIdentifier: string;
    clientType: string;
    companyName: string;
  }) => {
    navigate(`/client/${item.clientIdentifier}`);
  };

  return (
    <div>
      <TitleUF>{t("startPage.welcomeToMainframe")}</TitleUF>
      <HorizontalSpacer spacing={3} />
      <Lookup type="dropdown" onClickResult={onClickItem} />
    </div>
  );
};

export default ClientsPage;
